// NOTE: our apps currently only support US and UK clients, and this is an admin portal,
// so we can support only those country codes for now, and avoid importing another library.
export const countryCodes = [
  {
    label: '+44',
    value: '+44',
    regex: /^\+44/,
  },
  {
    label: '+1',
    value: '+1',
    regex: /^\+1/,
  },
] as const;

export type CountryCode = (typeof countryCodes)[number]['value'];

export function normalizePhoneNumber(countryCode: CountryCode, phoneNumber: string): string {
  // handle UK mobile number with possible prefix
  if (countryCode === '+44') {
    // remove '0' prefix if present
    const phoneNumberWithoutPrefix = phoneNumber.replace(/^07/, '7');
    return countryCode + phoneNumberWithoutPrefix;
  }

  return countryCode + phoneNumber;
}
